import { render, staticRenderFns } from "./newsLists.vue?vue&type=template&id=7da62e1b&scoped=true"
import script from "./newsLists.vue?vue&type=script&lang=js"
export * from "./newsLists.vue?vue&type=script&lang=js"
import style0 from "./newsLists.vue?vue&type=style&index=0&id=7da62e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da62e1b",
  null
  
)

export default component.exports